import React from "react"
import PropTypes from "prop-types"
import { Card, Typography, Tag, Row, Col, Flex } from "antd"
import styles from "../../index.module.css"
import { useTranslation } from "react-i18next"
import PhotoSlider from "components/common/PhotoSlider"
import { Title } from "ui/Typography"

const { Text, Paragraph } = Typography

const AboutTripCard = React.memo(({ description, boat }) => {
  const { t } = useTranslation()
  return (
    <Card className={styles.mainCard} title="About The Trip">
      <div className={`${styles.aboutTrip} p-xl`} style={{ maxHeight: 550, overflowY: "auto" }}>
        <Paragraph className={styles.description} ellipsis={boat?.length > 0 ? { rows: 4, expandable: true, symbol: "more" } : false}>
          {description}
        </Paragraph>
        {boat?.length > 0 && (
          <Flex vertical gap={20} className="mt-45">
            <Title level={4}>{t("trip.labels.equipment")}</Title>
            {boat?.map((item) => {
              const characteristics = item.characteristics || []
              return (
                <Card key={item.id}>
                  <Row gutter={[16, 16]} align="middle">
                    <Col xs={24} sm={6} className="mt-l">
                      <PhotoSlider photos={item.properties} cropped_photos={item.cropped_photos} preview />
                    </Col>

                    <Col xs={24} sm={16} className="mt-l ml-l">
                      <Title level={3}>{item.name || item.equipment_title}</Title>
                      <Paragraph style={{ display: "-webkit-box", WebkitLineClamp: 4, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                        {item.description}
                      </Paragraph>
                      <div>
                        {characteristics.map((char) => (
                          <Tag key={char.id} color="blue" style={{ marginBottom: "8px" }} className="mr-s">
                            {char.name}
                          </Tag>
                        ))}
                      </div>
                    </Col>
                  </Row>
                </Card>
              )
            })}
          </Flex>
        )}
      </div>
    </Card>
  )
})

AboutTripCard.propTypes = {
  description: PropTypes.string,
  boat: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      model: PropTypes.string,
      image: PropTypes.string,
      photos: PropTypes.arrayOf(PropTypes.string),
      description: PropTypes.string,
      custom_info: PropTypes.array
    })
  )
}

AboutTripCard.displayName = "AboutTripCard"

export default AboutTripCard
